/* eslint-disable indent */
import styled from 'styled-components';

// CONSTANTS
import colors from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const { radioCard } = colors;

const RadioContainer = styled.label`
  &.radio-card {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: ${p => `${p.height}px` || 'auto'};
    border: 1px solid ${radioCard.border};
    border-radius: 6px;
    padding: 25px;
    margin: 12px;
    cursor: pointer;
    box-shadow: 0 1px 3px ${radioCard.shadow};
    transition: 0.5s;
    ${p => {
      const backgroundColor = p.theme.overrides.MuiInputBase.root?.backgroundColor;
      return backgroundColor ? { backgroundColor } : null;
    }};

    &:hover {
      border-color: ${p => p.theme.palette.primary.main || colors.primary};

      ${breakpoints.down('xs')} {
        border-color: ${radioCard.border};
      }
    }

    &--checked {
      border-color: ${p => p.theme.palette.primary.main || colors.primary};
      box-shadow: 0 20px 40px ${radioCard.shadow};

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        box-shadow: 0 0 0 2px ${p => p.theme.palette.primary.main || colors.primary};
        border-radius: 6px;
      }

      &:before {
        content: '\\e918';
        position: absolute;
        top: -12px;
        right: -12px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'icomoon';
        font-size: 10px;
        height: 24px;
        width: 24px;
        border-radius: 50%;
        background-color: ${p => p.theme.palette.primary.main || colors.primary};
        color: ${radioCard.check};
        z-index: 1;
      }

      .radio-card__title,
      .radio-card__help-text {
        color: ${p => p.theme.palette.primary.main || colors.primary};
      }
    }

    .radio-card {
      &__title {
        font-size: 1.8rem;
        line-height: 2.2rem;
        font-weight: 600;
        text-align: center;
      }

      &__image {
        max-width: 110px;
        max-height: 100%;
      }
    }

    input[type='radio'] {
      display: none;
    }
  }
`;

export default RadioContainer;
